import React, { useState, useRef, useEffect } from "react";
import axios from "axios";

const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000'
  : 'https://myssa1.osc-fr1.scalingo.io';

const Btn = ({ children, variant = 'primary', onClick, disabled, style: s }) => {
  const base = {
    border: 'none', borderRadius: '7px', padding: '8px 16px',
    cursor: disabled ? 'not-allowed' : 'pointer', fontWeight: 600,
    fontSize: '13px', transition: 'opacity 0.2s', opacity: disabled ? 0.6 : 1,
  };
  const variants = {
    primary: { background: '#3498db', color: 'white' },
    success: { background: 'linear-gradient(135deg, #3a7d44, #66bb6a)', color: 'white' },
    danger:  { background: '#e74c3c', color: 'white' },
    ghost:   { background: '#f0f0f0', color: '#555' },
  };
  return (
    <button style={{ ...base, ...variants[variant], ...s }} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
};

const FILE_ICONS = {
  "Base article":                   "📦",
  "Commandes clients":              "🛒",
  "Commandes fournisseurs":         "🚚",
  "Base stock":                     "🏭",
  "Offre client":                   "📋",
  "Données paiements clients":      "💳",
  "Données paiements fournisseurs": "🏦",
  "Liste emplacements":             "📍",
};

const ALL_SCRIPTS = [
  'analyse_delai_approvisionnement.py', 'animation.py', 'base_de_donne_stock.py',
  'base_de_donnee_cmde_frn.py', 'base_de_donnee_cmde_client.py', 'camembert_1.py',
  'camembert_3.py', 'commande_a_10_jours_frn.py', 'commande_en_retard.py',
  'commandes_frn_sans_ar.py', 'emplacement_multi_ref.py', 'emplacement_vide.py',
  'plan_reception_fournisseur.py', 'commande_a_10_jours.py', 'commande_en_rupture.py',
  'donnee_histogramme.py', 'recalage_cmde_frn.py', 'commande_frn_recalage_stock_fort.py',
  'picking_log.py', 'base_de_donne_item.py', 'plan_expedition_cmde_client.py',
  'graph1.py', 'graph2.py', 'analyse_faisabilite.py', 'offre.py',
  'item_fin_de_mois.py', 'stock_projete.py', 'montant_vente.py',
  'montant_achat.py', 'evolution_stock.py',
];

const TOTAL_SCRIPTS = ALL_SCRIPTS.length;

const Dragdrop = () => {
  const fileNames = [
    "Base article", "Commandes clients", "Commandes fournisseurs", "Base stock",
    "Offre client", "Données paiements clients", "Données paiements fournisseurs", "Liste emplacements",
  ];
  const saveNames = [
    "I donnée client base article.xlsx", "I donnée client cmde client.xlsx",
    "I donnée client cmde frn.xlsx", "I donnée client stock.xlsx",
    "I donnée client offre.xlsx", "I donnee client paiement client.xlsx",
    "I donnée client paiement frn.xlsx", "I liste emplacement.xlsx",
  ];

  const [files, setFiles]             = useState(Array(8).fill(null));
  const [dragging, setDragging]       = useState(null);
  const [isRunning, setIsRunning]     = useState(false);
  const [progress, setProgress]       = useState(0);
  const [currentStep, setCurrentStep] = useState('');
  const [scriptError, setScriptError] = useState(false);
  const [done, setDone]               = useState(false);

  useEffect(() => {                                    // ← ajouter ici
    document.title = 'MYSSA – Drag & Drop';
  }, []);

  const esRef = useRef(null);

  useEffect(() => { return () => esRef.current?.close(); }, []);

  const handleDrop = (i, e) => {
    e.preventDefault(); setDragging(null);
    const file = e.dataTransfer.files[0]; if (!file) return;
    const n = [...files]; n[i] = file; setFiles(n);
  };
  const handleDragOver  = (i, e) => { e.preventDefault(); setDragging(i); };
  const handleDragLeave = () => setDragging(null);

  const handleClick = (i) => {
    if (isRunning) return;
    const input = document.createElement('input');
    input.type = 'file'; input.accept = '.xlsx,.xls,.csv';
    input.onchange = (e) => {
      const file = e.target.files[0]; if (!file) return;
      const n = [...files]; n[i] = file; setFiles(n);
    };
    input.click();
  };

  const handleRemove = (i, e) => {
    e.stopPropagation(); if (isRunning) return;
    const n = [...files]; n[i] = null; setFiles(n);
  };

  const fermerModal = () => {
    setIsRunning(false); setProgress(0);
    setCurrentStep(''); setScriptError(false); setDone(false);
  };

  const handleUploadAll = async () => {
    const filled = files.map((f, i) => f ? i : null).filter(i => i !== null);
    if (filled.length === 0) return;

    // Ouvre le modal IMMÉDIATEMENT
    setIsRunning(true);
    setProgress(0);
    setCurrentStep('Initialisation...');
    setScriptError(false);
    setDone(false);

    // Phase 1 : uploads (0 → 30%)
    try {
      for (let n = 0; n < filled.length; n++) {
        const i = filled[n];
        setCurrentStep(`Upload : ${saveNames[i]}`);
        const formData = new FormData();
        formData.append('file', files[i]);
        formData.append('newName', saveNames[i]);
        await axios.post(`${API}/upload`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        setProgress(Math.round(((n + 1) / filled.length) * 30));
      }
    } catch (err) {
      const msg = err.response?.data?.message || err.message || 'Erreur inconnue';
      setCurrentStep(`Erreur upload : ${msg}`);
      setScriptError(true);
      // NE PAS fermer le modal — laisser l'utilisateur voir l'erreur
      return;
    }

    // Phase 2 : SSE run-all (30 → 100%)
    setCurrentStep('Lancement du traitement des scripts...');
    esRef.current?.close();
    const es = new EventSource(`${API}/api/run-all`);
    esRef.current = es;

    let scriptsDone = 0;

    es.onmessage = (event) => {
      const raw = event.data;

      if (raw === '__DONE__') {
        es.close();
        setProgress(100);
        setCurrentStep('Traitement terminé avec succès ');
        setDone(true);
        return;
      }

      if (raw.startsWith('ERREUR:')) {
        setCurrentStep(raw.replace('ERREUR:', '').trim());
        setScriptError(true);
        es.close();
        return;
      }

      if (raw.startsWith('▶ Démarrage de')) {
        const name = raw.replace('▶ Démarrage de ', '').replace('...', '').trim();
        setCurrentStep(`Exécution : ${name}`);
      }

      if (raw.startsWith('') && raw.includes('terminé avec succès')) {
        scriptsDone++;
        setProgress(30 + Math.round((scriptsDone / TOTAL_SCRIPTS) * 70));
      }
    };

    es.onerror = () => {
      es.close();
      setCurrentStep('Connexion interrompue');
      setScriptError(true);
    };
  };

  const nbFilled = files.filter(f => f !== null).length;

  return (
    <div style={{ padding: '28px 32px', fontFamily: "'Segoe UI', sans-serif" }}>

      {/* ── Modal progression ── */}
      {isRunning && (
        <div style={{
          position: 'fixed', inset: 0, zIndex: 9999,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <div style={{
            background: '#fff', borderRadius: '12px', padding: '32px',
            width: '420px', boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
            fontFamily: "'Segoe UI', sans-serif",
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
              <p style={{ margin: 0, fontSize: '17px', fontWeight: 700, color: '#2c3e50' }}>
                ⚙️ Mise à jour des données
              </p>
            </div>

            <p style={{ fontSize: '13px', color: '#6c757d', marginBottom: '12px', minHeight: '18px' }}>
              {currentStep}
            </p>

            <div style={{ background: '#e9ecef', borderRadius: '99px', height: '8px', overflow: 'hidden', marginBottom: '6px' }}>
              <div style={{
                height: '100%', width: `${progress}%`,
                borderRadius: '99px', transition: 'width 0.4s ease',
                background: scriptError
                  ? '#e74c3c'
                  : 'linear-gradient(135deg, #3a7d44, #66bb6a)',
              }} />
            </div>

            <p style={{ textAlign: 'right', fontSize: '12px', color: '#aaa', marginBottom: '20px' }}>
              {progress}%
            </p>

            {(done || scriptError) && (
              <Btn
                variant={scriptError ? 'danger' : 'success'}
                onClick={fermerModal}
                style={{ width: '100%' }}
              >
                {scriptError ? 'Fermer (erreur)' : 'Fermer'}
              </Btn>
            )}
          </div>
        </div>
      )}

      {/* ── Header ── */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h1 style={{ margin: 0, fontSize: '22px', fontWeight: 700, color: '#2c3e50' }}>
          📂 Import des fichiers clients
        </h1>
        <Btn
          variant="success"
          onClick={handleUploadAll}
          disabled={isRunning || nbFilled === 0}
          style={{ padding: '10px 22px', fontSize: '14px' }}
        >
          {isRunning ? '⏳ En cours…' : `Enregistrer et lancer (${nbFilled})`}
        </Btn>
      </div>

      <div style={{ marginBottom: '16px', fontSize: '13px', color: '#888' }}>
        {nbFilled === 0
          ? 'Déposez vos fichiers Excel dans les zones ci-dessous, ou cliquez pour sélectionner.'
          : `${nbFilled} fichier${nbFilled > 1 ? 's' : ''} prêt${nbFilled > 1 ? 's' : ''} sur ${fileNames.length}`}
      </div>

      {/* ── Grille ── */}
      <div style={{ background: 'white', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.07)', padding: '24px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px' }}>
          {fileNames.map((name, i) => {
            const isFilled      = !!files[i];
            const isDraggingOver = dragging === i;
            return (
              <div key={i}
                onClick={() => handleClick(i)}
                onDrop={(e) => handleDrop(i, e)}
                onDragOver={(e) => handleDragOver(i, e)}
                onDragLeave={handleDragLeave}
                style={{
                  border: `2px dashed ${isDraggingOver ? '#3498db' : isFilled ? '#2ecc71' : '#d0d7de'}`,
                  borderRadius: '10px', height: '130px',
                  display: 'flex', flexDirection: 'column',
                  alignItems: 'center', justifyContent: 'center', gap: '8px',
                  cursor: isRunning ? 'default' : 'pointer',
                  transition: 'all 0.2s', position: 'relative',
                  background: isDraggingOver ? '#ebf5fb' : isFilled ? '#eafaf1' : '#fafbfc',
                  opacity: isRunning ? 0.85 : 1,
                }}
              >
                <span style={{ fontSize: '26px', lineHeight: 1 }}>
                  {isFilled ? '✅' : FILE_ICONS[name] || '📄'}
                </span>
                <span style={{
                  fontSize: '12px', fontWeight: 600, textAlign: 'center',
                  color: isFilled ? '#1a7a40' : '#6c757d', padding: '0 8px', lineHeight: 1.3,
                }}>
                  {isFilled ? files[i].name : name}
                </span>
                {isFilled && <span style={{ fontSize: '11px', color: '#888' }}>{(files[i].size / 1024).toFixed(0)} Ko</span>}
                {isFilled && !isRunning && (
                  <button onClick={(e) => handleRemove(i, e)} style={{
                    position: 'absolute', top: '6px', right: '8px',
                    background: 'none', border: 'none', cursor: 'pointer',
                    fontSize: '16px', color: '#aaa', lineHeight: 1, padding: '2px',
                  }}>×</button>
                )}
                {!isFilled && <span style={{ fontSize: '10px', color: '#b0b8c1', marginTop: '2px' }}>Glisser ou cliquer</span>}
              </div>
            );
          })}
        </div>
      </div>

      <div style={{ display: 'flex', gap: '20px', marginTop: '16px', fontSize: '12px', color: '#888' }}>
        <span><span style={{ display: 'inline-block', width: '10px', height: '10px', borderRadius: '2px', background: '#eafaf1', border: '1.5px solid #2ecc71', marginRight: '5px' }} />Fichier chargé</span>
        <span><span style={{ display: 'inline-block', width: '10px', height: '10px', borderRadius: '2px', background: '#fafbfc', border: '1.5px dashed #d0d7de', marginRight: '5px' }} />En attente</span>
      </div>
    </div>
  );
};

export default Dragdrop;